<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="large" color="#156572" type="ball-clip-rotate-multiple"></ngx-spinner>

<router-outlet></router-outlet>